<template>
  <div class="container-story disp-scroll">
    <!-- リンクコピー用 -->
    <input type="hidden" style="opacity: 0 !important;" id="copy-code" :value="copyURL"/>    
    <!-- ストーリーの削除をしても良いか聞くモーダル -->
    <b-modal width="500px" :active.sync="isDeleteStoryModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title" style="font-size: 24px;">
            求人ノベルの削除
          </p>
        </header>
        <div class="card-content">
          <h2 style="font-size: larger;">求人ノベルを削除してもよろしいですか？</h2>
          <div style="display: flex; justify-content: space-around; align-items: center; flex-wrap: wrap;">
            <button style="width: 140px;" class="button is-primary" @click="deleteStory(tempDeleteStory.story_id)">削除</button>
            <button style="width: 140px; background: #f4a460; border: none;" class="button" @click="archiveStory(tempDeleteStory, true)" v-if="!isDelete">アーカイブする</button>
            <button style="width: 140px;" class="button" @click="isDeleteStoryModal=false">キャンセル</button>
          </div>
        </div>
      </div>
    </b-modal>
    <div class="header-box">
      <div class="header-menu">
        <p><b style="font-size:28px; font-weight: 800;">Story</b></p>
        <p style="margin-left: 25px; font-size:16px; color: #666; margin-top: 8px;">求人ノベル管理画面</p>
      </div>
      <button @click="createStory()" class="button is-primary" v-if="!isNew">
        <span class="mdi mdi-pen" style="margin-right: 16px;"></span>求人ノベルを作成する
      </button>
      <button class="button is-primary" v-if="isNew">
        <span class="mdi mdi-loading mdi-spin" style="margin-right: 16px;"></span>作成中です
      </button>
    </div>
    <div class="main-container">
      <div style="width: 100%; display: flex; padding-left: 32px; padding-bottom: 8px;">
        <div class="tabs is-toggle is-small">
          <div>
            <input class="input" style="width: 200px; margin-right: 10px;" placeholder="🔎ノベル名で検索"  v-model="searchStoryName" />
          </div>
          <ul>
            <li :class="{'is-active': !archiveSwitch}">
              <a style="width: 128px;" @click="archiveSwitch=false"><span>一覧</span></a>
            </li>
            <li :class="{'is-active': archiveSwitch}">
              <a style="width: 128px;" @click="archiveSwitch=true"><span>アーカイブ</span></a>
            </li>
          </ul>
        </div>
      </div>
      <div style="potition: absolute; top: 40%;" v-if="isStoryLoading">
        <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
      </div>
      <div style="width: 100%; height: calc(100vh - 80px);" v-else>
        <draggable id="story-list" :list="storyLists" @end="saveStoryOrder(storyLists)" :options="{animation: 300, group: { name: 'STORY', pull: 'clone', put: false}, handle: '.drag-button'}" v-if="!archiveSwitch">
          <div class="story-box" v-for="(s, idx) in storyLists" :key="idx" v-if="!s.is_archive && searchResult(s)" @dragstart="startDrag(s)">
            <div class="left-box">
              <img :src="getBackgroundScene(s)"/>
            </div>
            <div class="right-box">
              <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                <div class="desc-line">
                  <div style="text-align: left; margin-bottom: 4px; width: 100%; float: left; display: flex; justify-content: flex-start; align-items: center;">
                    <p style="display: block; text-overflow: ellipsis; white-space: nowrap; width: auto; max-width: 100%; overflow: hidden;">{{s.title}}</p>
                  </div>
                  <div style="display: flex; justify-content: flex-start; align-items: center; margin-bottom: 4px;">
                    <b-tag type="is-info" v-if="s.is_public">求人一覧に公開</b-tag>
                    <b-tag v-else>非公開</b-tag>
                    <p style="margin-left: 8px; margin-right: 8px;"><span class="mdi mdi-eye"></span> {{s.pv_count}}</p>
                    <p style="color: red;"><span class="mdi mdi-heart"></span> {{s.gv_count}}</p>
                  </div>
                  <p>作成日：{{new Date(s.updated_at).toLocaleString('ja-JP')}}</p>
                </div>
                <div class="unread-parent">
                  <div>
                    <span class="new-messages unread-child" v-if="s.unread != 0 && s.unread != null">New!{{s.unread}}</span>
                  </div>
                  <div class="msg-container">
                    <div v-if="loginCheck()" @click="openDrawerMenu(); getUserActionData(s)" class="msg-btn mdi mdi-message-text-outline"></div>
                  </div>
                </div>
              </div>
              <div class="menu-line">
                <a class="button is-small is-primary" :href="'/recruits/story/' + s.company_id + '/' + s.story_id" target="_blank" rel="noopener">プレビュー</a>
                <button class="button is-small" style="background: #e99; border: none;" v-if="$isClient()" @click="copyLink(s.company_id,s.story_id)">公開リンク</button>
                <button class="button is-small" style="background: #e99; border: none;" v-if="$isUser()" @click="copyLink(s.user,s.story_id)">公開リンク</button>
                <button class="button is-small" style="background: #ec9; border: none;" @click="copyStory(s, idx)">複製する</button>
                <button class="button is-small" style="background: #f8f8f8; border: none;" @click="moveStoryEdit(s.story_id)">編集する</button>
                <button class="button is-small drag-button" style="background: #f8a; border: none;" >移動する</button>
                <button class="button is-small" style="background: #e9c; border: none;" @click="exportStory(s.story_id)" v-if="!isExportLoading">エクスポート</button>
                <button class="button is-small" style="background: #e9c; border: none;" v-if="isExportLoading"><span class="mdi mdi-loading mdi-spin"></span></button>
                <button class="button is-small" style="background: #f4a460; border: none;" @click="archiveStory(s, true)">アーカイブ</button>
                <button class="button is-small is-danger" @click="isDeleteStoryModal=true;tempDeleteStory=s">削除する</button>
              </div>
            </div>
          </div>
          <div class="story-box" style="background-color:white" v-if="storyLists.length != 0 && storyLists.length % 2 != 0"></div>
        </draggable>
        <draggable id="story-list-archive" :list="storyArchives" @end="saveStoryOrder(storyArchives)" :options="{animation: 300, group: { name: 'ARCHIVE', pull: 'clone', put: false}, handle: '.drag-button'}" v-else>
          <div class="story-box" v-for="(s, idx) in storyArchives" :key="idx" v-if="s.is_archive && searchResult(s)">
            <!-- <button class="button drag-button">
              <span class="mdi mdi-drag-vertical mdi-24px"></span>
            </button> -->
            <div class="left-box">
              <img :src="getBackgroundScene(s)"/>
            </div>
            <div class="right-box">
              <div class="desc-line">
                <div style="text-align: left; margin-bottom: 4px; width: 100%; float: left; display: flex; justify-content: flex-start; align-items: center;">
                  <p style="display: block; text-overflow: ellipsis; white-space: nowrap; width: auto; max-width: 100%; overflow: hidden;">{{s.title}}</p>
                </div>
                <div style="display: flex; justify-content: flex-start; align-items: center; margin-bottom: 4px;">
                  <b-tag>{{s.is_public ? '公開' : '非公開'}}</b-tag>
                  <p style="margin-left: 8px; margin-right: 8px;"><span class="mdi mdi-eye"></span> {{s.pv_count}}</p>
                  <p style="color: red;"><span class="mdi mdi-heart"></span> {{s.gv_count}}</p>
                </div>
                <p>作成日：{{new Date(s.updated_at).toLocaleString('ja-JP')}}</p>
              </div>
              <div class="menu-line">
                <button class="button is-small" style="width:100%;margin-right: 8px; background: #f4a460; border: none;" @click="archiveStory(s, false)">元に戻す</button>
                <button class="button is-small is-danger" style="width:100%;margin-right: 8px;" @click="isDeleteStoryModal=true;tempDeleteStory=s;isDelete=true">削除する</button>
              </div>
            </div>
          </div>
          <div class="story-box"  style="background-color:white" v-if="storyArchives.length != 0 && storyArchives.length % 2 != 0"></div>
        </draggable>
      </div>
      <!-- 求人ノベルが存在しない場合 -->
      <div class="no-story" v-if="stories.length == 0 && !isStoryLoading">
        <img src="@/assets/template/make_story.png"/>
        <p style="text-align: left;">
          求人ノベルは、求職者様に対して、仕事の内容や面接内容、入社までの流れなどを
          物語形式にお伝えすることができます。
          より、入社後のイメージや会社の雰囲気を明確に伝えることができます。
        </p>
        <hr>
        <button @click="createStory()" class="button is-primary" v-if="!isNew">
          <span class="mdi mdi-pen" style="margin-right: 16px;"></span>求人ノベルを作成する
        </button>
        <button class="button is-primary" v-if="isNew">
          <span class="mdi mdi-loading mdi-spin" style="margin-right: 16px;"></span>作成中です
        </button>
      </div>
    </div>
    <div :class="{'modal-mask': drawerFlg}" @click="closeDrawerMenu"></div>
    <transition name="right"
      v-on:after-leave="afterLeave"
    >
      <div v-if="drawerFlg" class="drawer-menu-wrapper">
        <div class="drawer-menu">
          <i @click="closeDrawerMenu" class="close-btn mdi mdi-close"></i>
          <h1>読者のコメントとアクション</h1>
          <section class="new-messages-container">
            <div class="unread-zero">
              <span class="new-messages -item" v-if="storyUserAction.unread_zero != 0">New!{{storyUserAction.unread_zero}}</span>
            </div>
            <div class="unread-one">
              <span class="new-messages -item" v-if="storyUserAction.unread_one != 0">New!{{storyUserAction.unread_one}}</span>
            </div>
            <div class="unread-two">
              <span class="new-messages -item" v-if="storyUserAction.unread_two != 0">New!{{storyUserAction.unread_two}}</span>
            </div>
          </section>
          <div class="unread-parent">
            <div class="tab-container">
              <b-tabs type="is-boxed" expanded>
                  <b-tab-item label="話を聞きにいきたい" icon="human-greeting" class="unread-parent">
                    <div  v-if="!replyWantToMeet.replyEmailWindow" class="action-list disp-scroll">
                      <table class="action-table" border="1" width="100%" cellspacing="0" cellpadding="5" bordercolor="#dbdbdb">
                        <tr>
                          <th width="4%"><font></font></th>
                          <th width="20%"><font>氏名</font></th>
                          <th width="36%"><font>Email</font></th>
                          <th width="20%"><font>申請日</font></th>
                          <th width="16%"><font></font></th>
                          <th width="4%"><font></font></th>
                        </tr>
                        <tr v-for="(w, i) in storyUserAction.wantToMeet" :key="i">
                          <td>
                            <span class="unread-mark" v-if="w.is_already==false"></span>
                            <span class="already-read-mark" v-else></span>
                          </td>
                          <td>{{w.user_name}}</td>
                          <td valign="top">{{w.email}}</td>
                          <td valign="top">{{w.created_at}}</td>
                          <td valign="top" align="middle">
                            <button class="button is-small is-primary" @click="replyEmail(w); readComment(w.pk)">
                              返信する
                            </button>
                          </td>
                          <td style="padding-left:2px;padding-right:2px;vertical-align: middle;">
                            <div v-if="w.reply_date!=''" class="maru size_normal red_already">
                              <div class="letter_already">済</div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div v-if="replyWantToMeet.replyEmailWindow && !replyWantToMeet.nextReplyEmailMsg" class="action-list">
                      <article>
                        <div class="arrow-left-wrapper" style='display: flex; justify-content: space-between; align-items: center;'>
                          <i @click="replyWantToMeet.replyEmailWindow = false" class="mdi mdi-arrow-left mdi-24px"></i>
                          <p>送信者名: {{replyWantToMeet.sendInfo.user_name}}</p>
                        </div>
                        <div>
                          <p class="reply-p">返信内容を入力してください。</p>
                          <textarea v-model="replyWantToMeet.replyEmailMsg" class="reply-textarea textarea disp-scroll"></textarea>
                        </div>
                        <div>
                          <button @click="replyWantToMeet.nextReplyEmailMsg = true" class="button is-primary">次へ</button>
                        </div>
                      </article>
                    </div>
                    <div class="action-list">
                      <article v-if="replyWantToMeet.nextReplyEmailMsg">
                        <div class="arrow-left-wrapper" style='display: flex; justify-content: space-between; align-items: center;'>
                          <i @click="replyWantToMeet.nextReplyEmailMsg = false" class="mdi mdi-arrow-left mdi-24px"></i>
                          <p>送信者名: {{replyWantToMeet.sendInfo.user_name}}</p>
                        </div>
                        <p class="reply-email-msg-check-p">以下の内容でお間違えなければ、送信ボタンを押してください。</p>
                        <div class="reply-email-msg-check disp-scroll">{{replyWantToMeet.replyEmailMsg}}</div>
                        <div class="mail-send-btn-wrapper">
                          <button @click="replyWantToMeet.nextReplyEmailMsg = false" class="btn button">修正</button>
                          <button @click="sendReplyEmail(0, replyWantToMeet)" class="btn button is-primary">送信</button>
                        </div>
                      </article>
                    </div>
                  </b-tab-item>
                  <b-tab-item label="読了報告" icon="book-open-page-variant">
                    <div v-if="!replyFinishReading.replyEmailWindow" class="action-list disp-scroll">
                      <table class="action-table" v-if="finishReadingComment == null" border="1" width="100%" cellspacing="0" cellpadding="5" bordercolor="#dbdbdb">
                        <tr>
                          <th width="4%"><font></font></th>
                          <th width="20%"><font>氏名</font></th>
                          <th width="36%"><font>読んだノベル</font></th>
                          <th width="20%"><font>報告日</font></th>
                          <th width="16%"><font></font></th>
                          <th width="4%"><font></font></th>
                        </tr>
                        <tr class="finish-reading" v-for="(w, i) in storyUserAction.finishReading" :key="i">
                          <td @click="finishReadingListClick(w); readComment(w.pk)">
                            <span class="unread-mark" v-if="w.is_already==false"></span>
                            <span class="already-read-mark" v-else></span>
                          </td>
                          <td @click="finishReadingListClick(w); readComment(w.pk)">{{w.user_name}}</td>
                          <td @click="finishReadingListClick(w); readComment(w.pk)" valign="top">{{w.title}}</td>
                          <td @click="finishReadingListClick(w); readComment(w.pk)" valign="top">{{w.created_at}}</td>
                          <td valign="top" align="middle">
                            <button class="button is-small is-primary" @click="replyEmail(w); readComment(w.pk)">
                              返信する
                            </button>
                          </td>
                          <td @click="finishReadingListClick(w); readComment(w.pk)" style="padding-left:2px;padding-right:2px;vertical-align: middle;">
                            <div v-if="w.reply_date!=''" class="maru size_normal red_already">
                              <div class="letter_already">済</div>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <div v-if="finishReadingComment != null">
                        <div class="arrow-left-wrapper" style='display: flex;'>
                          <i @click="finishReadingComment = null" class="mdi mdi-arrow-left mdi-24px"></i>
                          <div style="display: inline; margin: auto 0 0 auto">送信者名: {{finishReadingComment.user_name}}</div>
                        </div>
                        <div class="question-comment-wrapper">{{finishReadingComment.comment}}</div>
                        <div>
                          <button class="button is-primary" style="margin-top:8px;" @click="replyEmail(finishReadingComment); readComment(finishReadingComment.pk)">
                            返信する
                          </button>
                        </div>
                      </div>
                    </div>
                    <p v-if="finishReadingComment == null" style="margin-top: 8px; text-align: left; font-size: 12px;">項目クリックで報告内容を表示します。</p>
                    <div v-if="replyFinishReading.replyEmailWindow && !replyFinishReading.nextReplyEmailMsg" class="action-list disp-scroll">
                      <article>
                        <div class="arrow-left-wrapper" style='display: flex; justify-content: space-between; align-items: center;'>
                          <i @click="replyFinishReading.replyEmailWindow = false" class="mdi mdi-arrow-left mdi-24px"></i>
                          <div style="display: inline; margin: auto 0 0 auto">送信者名: {{replyFinishReading.sendInfo.user_name}}</div>
                        </div>
                        <p class="sent-p">送信された内容</p>
                        <div class="finish-reading-comment-reply-wrapper">{{replyFinishReading.sendInfo.comment}}</div>
                        <div>
                          <p class="reply-p">返信内容を入力してください。</p>
                          <textarea v-model="replyFinishReading.replyEmailMsg" class="reply-textarea textarea disp-scroll"></textarea>
                        </div>
                        <div>
                          <button @click="replyFinishReading.nextReplyEmailMsg = true" class="button is-primary">次へ</button>
                        </div>
                      </article>
                    </div>
                    <div class="action-list">
                      <article v-if="replyFinishReading.nextReplyEmailMsg">
                        <div class="arrow-left-wrapper" style='display: flex; justify-content: space-between; align-items: center;'>
                          <i @click="replyFinishReading.nextReplyEmailMsg = false" class="mdi mdi-arrow-left mdi-24px"></i>
                          <p>送信者名: {{replyFinishReading.sendInfo.user_name}}</p>
                        </div>
                        <p class="reply-email-msg-check-p">以下の内容でお間違えなければ、送信ボタンを押してください。</p>
                        <div class="reply-email-msg-check disp-scroll">{{replyFinishReading.replyEmailMsg}}</div>
                        <div class="mail-send-btn-wrapper">
                          <button @click="replyFinishReading.nextReplyEmailMsg = false" class="btn button">修正</button>
                          <button @click="sendReplyEmail(1, replyFinishReading)" class="btn button is-primary">送信</button>
                        </div>
                      </article>
                    </div>
                  </b-tab-item>
                  <b-tab-item label="質問する" icon="help">
                    <div v-if="!replyQuestion.replyEmailWindow" class="action-list disp-scroll">
                      <table class="action-table" v-if="questionComment == null" border="1" width="100%" cellspacing="0" cellpadding="5" bordercolor="#dbdbdb">
                        <tr>
                          <th width="4%"><font></font></th>
                          <th width="20%"><font>氏名</font></th>
                          <th width="36%"><font>読んだノベル</font></th>
                          <th width="20%"><font>質問日</font></th>
                          <th width="16%"><font></font></th>
                          <th width="4%"><font></font></th>
                        </tr>
                        <tr class="question" v-for="(w, i) in storyUserAction.question" :key="i">
                          <td @click="questionListClick(w); readComment(w.pk)">
                            <span class="unread-mark" v-if="w.is_already==false"></span>
                            <span class="already-read-mark" v-else></span>
                          </td>
                          <td @click="questionListClick(w); readComment(w.pk)">{{w.user_name}}</td>
                          <td @click="questionListClick(w); readComment(w.pk)" valign="top">{{w.title}}</td>
                          <td @click="questionListClick(w); readComment(w.pk)" valign="top">{{w.created_at}}</td>
                          <td valign="top" align="middle">
                            <button class="button is-small is-primary" @click="replyEmail(w); readComment(w.pk)">
                              返信する
                            </button>
                          </td>
                          <td @click="questionListClick(w); readComment(w.pk)" style="padding-left:2px;padding-right:2px;vertical-align: middle;">
                            <div v-if="w.reply_date!=''" class="maru size_normal red_already">
                              <div class="letter_already">済</div>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <div v-if="questionComment != null">
                        <div class="arrow-left-wrapper" style='display: flex;'>
                          <i @click="questionComment = null" class="mdi mdi-arrow-left mdi-24px"></i>
                          <div style="display: inline; margin: auto 0 0 auto">送信者名: {{questionComment.user_name}}</div>
                        </div>
                        <div class="question-comment-wrapper">{{questionComment.comment}}</div>
                        <div>
                          <button class="button is-primary" style="margin-top:8px;" @click="replyEmail(questionComment); readComment(questionComment.pk)">
                            返信する
                          </button>
                        </div>
                      </div>
                    </div>
                    <p v-if="questionComment == null" style="margin-top: 8px; text-align: left; font-size: 12px;">項目クリックで質問内容を表示します。</p>
                    <div v-if="replyQuestion.replyEmailWindow && !replyQuestion.nextReplyEmailMsg" class="action-list disp-scroll">
                      <article>
                        <div class="arrow-left-wrapper" style='display: flex; justify-content: space-between; align-items: center;'>
                          <i @click="replyQuestion.replyEmailWindow = false" class="mdi mdi-arrow-left mdi-24px"></i>
                          <div style="display: inline; margin: auto 0 0 auto">送信者名: {{replyQuestion.sendInfo.user_name}}</div>
                        </div>
                        <p class="sent-p">送信された内容</p>
                        <div class="question-comment-reply-wrapper">{{replyQuestion.sendInfo.comment}}</div>
                        <div>
                          <p class="reply-p">返信内容を入力してください。</p>
                          <textarea v-model="replyQuestion.replyEmailMsg" class="reply-textarea textarea disp-scroll"></textarea>
                        </div>
                        <div>
                          <button @click="replyQuestion.nextReplyEmailMsg = true" class="button is-primary">次へ</button>
                        </div>
                      </article>
                    </div>
                    <div class="action-list">
                      <article v-if="replyQuestion.nextReplyEmailMsg">
                        <div class="arrow-left-wrapper" style='display: flex; justify-content: space-between; align-items: center;'>
                          <i @click="replyQuestion.nextReplyEmailMsg = false" class="mdi mdi-arrow-left mdi-24px"></i>
                          <p>送信者名: {{replyQuestion.sendInfo.user_name}}</p>
                        </div>
                        <p class="reply-email-msg-check-p">以下の内容でお間違えなければ、送信ボタンを押してください。</p>
                        <div class="reply-email-msg-check disp-scroll">{{replyQuestion.replyEmailMsg}}</div>
                        <div class="mail-send-btn-wrapper">
                          <button @click="replyQuestion.nextReplyEmailMsg = false" class="btn button">修正</button>
                          <button @click="sendReplyEmail(2, replyQuestion)" class="btn button is-primary">送信</button>
                        </div>
                      </article>
                    </div>
                  </b-tab-item>
                  <b-tab-item label="クイズ回答" icon="account-alert">
                    <div class="action-list disp-scroll">
                      <table class="action-table" v-if="answerDetail==null" border="1" width="100%" cellspacing="0" cellpadding="5" bordercolor="#dbdbdb">
                        <tr>
                          <th width="50%"><font>質問文</font></th>
                          <th width="15%"><font>回答者</font></th>
                          <th width="15%"><font>結果</font></th>
                          <th width="20%"><font>回答日時</font></th>
                        </tr>
                        <tr class="question" @click="clickAnswerDetail(a)" v-for="(a, i) in storyQuizAnswers" :key="i">
                          <td>{{a.question}}</td>
                          <td valign="top">{{a.respondent_name == '' ? '匿名' : a.respondent_name}}</td>
                          <td valign="top">{{a.answer==0 ? '(正解)' : '(不正解)'}}</td>
                          <td valign="top">{{displayDate(a.created_at)}}</td>
                        </tr>
                      </table>
                      <div v-else>
                        <div class="arrow-left-wrapper" style='display: flex;'>
                          <i @click="answerDetail = null" class="mdi mdi-arrow-left mdi-24px"></i>
                          <div style="display: inline; margin: auto 0 0 auto">回答者名: {{answerDetail.respondent_name == '' ? '匿名' : answerDetail.respondent_name}}</div>
                        </div>
                        <div class="quiz-question-wrapper">{{answerDetail.question}}</div>
                        <div class="quiz-result-wrapper">
                          <div class="quiz-result">結果：
                            <span :class="answerDetail.answer==0 ? 'quiz-collect' : 'quiz-incollect'">
                              {{ answerDetail.answer == 0 ? '正解' : '不正解'}}</span></div>
                        </div>
                        <div :class="['quiz-choice-wrapper', {'quiz-select' : answerDetail.answer==i}]" v-for="(c,i) in answerDetail.choices" :key="i">
                          <span :class="i==0 ? 'quiz-collect' : 'quiz-incollect'">
                            {{i == 0 ? '正解答' : '不正解答'}}
                          </span>
                          ：{{c}}
                        </div>
                      </div>
                    </div>
                  </b-tab-item>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import moment from 'moment'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  name: 'StoryList',
  componentName: 'StoryList',
  components: {
    draggable
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('chatbot', ['story', 'stories', 'isStoryLoading', 'scenes', 'isExportLoading', 'storyUserAction', 'storyQuizAnswers']),
    ...mapState('mediapool', ['iconImages', 'isImageLoading']),
    storyLists () {
      let stlists = []
      for (var i in this.stories) {
        if (!this.stories[i].is_archive) {
          stlists.push(this.stories[i])
        }
      }
      return stlists
    },
    storyArchives () {
      let stlists = []
      for (var i in this.stories) {
        if (this.stories[i].is_archive) {
          stlists.push(this.stories[i])
        }
      }
      return stlists
    },
  },
  data () {
    return {
      reloadUserActionData: {},
      isNew: false,
      isDeleteStoryModal: false,
      tempDeleteStory: null,
      copyURL: '',
      drawerFlg: false,
      finishReadingComment: null,
      questionComment: null,
      archiveSwitch: false,
      replyWantToMeet: {
        replyEmailWindow: false,
        replyEmailMsg: '',
        nextReplyEmailMsg: false,
        sendInfo: {},
      },
      replyFinishReading: {
        replyEmailWindow: false,
        replyEmailMsg: '',
        nextReplyEmailMsg: false,
        sendInfo: {},
      },
      isDelete: false,
      replyQuestion: {
        replyEmailWindow: false,
        replyEmailMsg: '',
        nextReplyEmailMsg: false,
        sendInfo: {},
      },
      orgImageCount: 0,
      isImageLoadEnd: false,
      searchStoryName: '',
      dragCard: [],
      answerDetail: null
    }
  },
  mounted () {
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)
    if (this.$isClient()) {
      this.$store.dispatch('mediapool/getIconOrgImages')
    } else if (this.$isUser()) {
      console.log('isUser')
    }
  },
  watch: {
    story () {
      if (this.isNew) {
        let createScene = {
          scene_type: 0,
          scene_order: 1,
          story: this.story.story_id,
          main_character: null
        }
        this.$store.dispatch('chatbot/createScene', createScene)
      }
    },
    scenes: {
      handler () {
        if (this.isNew) {
          this.isNew = false
          if (this.$isClient()) {
            this.$router.push('/dashboard/story/edit/' + this.story.story_id)
          } else if(this.$isUser()) {
            this.$router.push('/recruits/storyedit/' + this.story.story_id)
          }
        }
      },
      deep: true
    }
  },
  methods: {
    readComment (id) {
      this.$store.dispatch('chatbot/readComment', {'pk': id})
      .then(() => {
        this.$store.dispatch('chatbot/getStory')
        this.$store.dispatch('chatbot/getStoryUserAction', this.reloadUserActionData.story_id)
      })
    },
    createStory () {
      this.sendControlLog('求人ノベル　新規作成', '求人ノベル管理画面にて、「求人ノベルを作成する」ボタンをクリックした。')
      let createDate = {
        title: 'no title',
        description: '',
      }
      this.$store.dispatch('chatbot/createStory', createDate)
      this.isNew = true
    },
    getBackgroundScene (story) {
      if (story.icon_ref) {
        for (let img of this.iconImages) {
          if (img.pk == story.icon_ref) {
            return img.image_data
          }
        }
      }
      // デフォルト画像から使う
      return require('@/assets/scene/' + story.icon_type + '.jpg')
    },
    deleteStory (id) {
      this.sendControlLog('求人ノベル　削除', '求人ノベル管理画面にて、「削除」ボタンをクリックした。')
      this.$store.dispatch('chatbot/deleteStory', id)
      this.isDeleteStoryModal = false
      this.isDelete = false
      setTimeout(() => {
        this.$store.dispatch('chatbot/getStory')
      },500)
    },
    moveStoryEdit (id) {
      this.sendControlLog('求人ノベル　編集', '求人ノベル管理画面にて、「編集する」ボタンをクリックした。')
      if (this.$isClient()) {
        this.$router.push('/dashboard/story/edit/' + id)
      } else if (this.$isUser()) {
        this.$router.push('/recruits/storyedit/' + id)
      }
    },
    exportStory (id) {
      this.$store.dispatch('chatbot/exportStoryView', id)
    },
    copyStory (s, i) {
      this.$store.dispatch('chatbot/copyStory', {data: s, idx: i})
    },
    copyLink (s_company_id,s_story_id) {
      this.copyURL =  process.env.OWN_ENDPOINT + '/cb_share/story/' + s_company_id + '/' + s_story_id
      this.$nextTick(() => {
        let codeToCopy = document.querySelector('#copy-code')
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        document.execCommand('copy')
        this.$buefy.snackbar.open({
          message: '求人ノベル表示URLをコピーしました！',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      })
    },
    openDrawerMenu () {
      this.drawerFlg = true
    },
    closeDrawerMenu () {
      this.drawerFlg = false
      this.resetReplyFinishReading ()
    },
    getUserActionData (s) {
      this.$store.dispatch('chatbot/getStoryUserAction', s.story_id)
      this.$store.dispatch('chatbot/getStoryQuizAnswer', s.story_id)
      this.reloadUserActionData = s
    },
    finishReadingListClick (w) {
      this.finishReadingComment = w
    },
    questionListClick (w) {
      this.questionComment = w
    },
    clickAnswerDetail (a) {
      this.answerDetail = a
    },
    saveStoryOrder (stories){
      let storyList = []
      storyList = this.stories
      // ドラッグしたカードをstoryListから削除
      const dragCardIdx = storyList.indexOf(this.dragCard)
      if(dragCardIdx >= 0){
        storyList.splice(dragCardIdx, 1)
      }
      // 配列からドラッグした場所の1つ前のシナリオを探して後ろにdragCardを挿入
      for (let i in stories) {
        if (stories[i] == this.dragCard && stories[i - 1] == undefined) {
          storyList.unshift(this.dragCard)
        } else if (stories[i] == this.dragCard && stories[i - 1] != undefined) {
          const prevStory = stories[i - 1]
          const insertIdx = storyList.indexOf(prevStory) + 1
          storyList.splice(insertIdx, 0, this.dragCard)
        }
      }
      // story_orderを振り直してアップデート
      let obj = []
      for (let i in storyList) {
        storyList[i].story_order = Number(i) + 1
        obj.push(storyList[i])
      }
      this.$store.dispatch('chatbot/updateOrderStory', obj)
    },
    archiveStory (s, flg) {
      let updateStory = s
      updateStory.is_archive = flg
      this.$store.dispatch('chatbot/updateStory', updateStory)
      this.isDeleteStoryModal = false
    },
    loginCheck () {
      return this.$isClient()
    },
    replyEmail (w) {
      if (w.action_type == 0) {
        this.replyWantToMeet.sendInfo = w
        this.replyWantToMeet.replyEmailWindow = true
      } else if (w.action_type == 1) {
        this.replyFinishReading.sendInfo = w
        this.replyFinishReading.replyEmailWindow = true
      } else if (w.action_type == 2) {
        this.replyQuestion.sendInfo = w
        this.replyQuestion.replyEmailWindow = true
      }
    },
    resetReplyWantToMeet () {
      this.replyWantToMeet.replyEmailWindow = false
      this.replyWantToMeet.nextReplyEmailMsg = false
      this.replyWantToMeet.sendInfo = {}
      this.replyWantToMeet.replyEmailMsg = ''
    },
    resetReplyFinishReading () {
      this.replyFinishReading.replyEmailWindow = false
      this.replyFinishReading.nextReplyEmailMsg = false
      this.replyFinishReading.sendInfo = {}
      this.replyFinishReading.replyEmailMsg = ''
      this.finishReadingComment = null
    },
    resetReplyQuestion () {
      this.replyQuestion.replyEmailWindow = false
      this.replyQuestion.nextReplyEmailMsg = false
      this.replyQuestion.sendInfo = {}
      this.replyQuestion.replyEmailMsg = ''
      this.questionComment = null
    },
    sendReplyEmail (type, replyData) {
      var data = {
        action_pk:     replyData.sendInfo.pk,
        email_content: replyData.replyEmailMsg
      }

      if (type == 0) {
        this.resetReplyWantToMeet()
      }
      else if (type == 1) {
        this.resetReplyFinishReading()
      }
      else if (type == 2) {
        this.resetReplyQuestion()
      }
      this.$store.dispatch('chatbot/replyEmail', data)
        .then(() => {
          this.$store.dispatch('chatbot/getStoryUserAction', this.reloadUserActionData.story_id)
        })
    },
    afterLeave: function (e) {
      this.finishReadingComment = null
      this.questionComment = null
      this.resetReplyWantToMeet()
      this.resetReplyFinishReading()
      this.resetReplyQuestion()
    },
    searchResult (s) {
      if (this.searchStoryName === '') {
        return true
      }
      return s.title.toLowerCase().indexOf(this.searchStoryName.toLowerCase()) >= 0
    },
    startDrag (story) {
      this.dragCard = story
    },
    displayDate (d) {
      return moment(d).format('YYYY/MM/DD HH:mm')
    },
  }
}
</script>

<style scoped lang="scss">
.container-story {
  height: 100vh;
  width: 100%;
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 25px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-container {
  height: calc(100vh - 80px);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
#story-list{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}
#story-list-archive{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width:100%
}
.story-box {
  height: 180px;
  width: calc(50% - 16px);
  min-width: 440px;
  display: flex; 
  justify-content: center;
  align-items: center;
  padding: 8px;
  background: #ffeef8;
  margin: 8px;
}
.left-box {
  width:  128px;
  height: calc(180px - 32px);
}
.left-box > img {
  width:  100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(90%) blur(0.5px);
}
.right-box {
  width: calc(100% - 128px);
  height: calc(180px - 32px);
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: smaller;
  position: relative;
  .info-wrapper {
    display: flex;
  }
}
.right-box > p {
  text-align: left;
  font-size: medium;
  width: 100%;
}
.desc-line {
  width: calc(100% - 48px);
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}
.desc-line > p {
  text-align: left;
  width: 100%;
}
.menu-line {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.menu-line > button {
  width: calc(25% - 4px);
  min-width: 60px;
  height: 28px;
  margin: 4px;
  margin-right: 2px;
  margin-left:  2px;
  margin-bottom:  2px;
  overflow: hidden;
}
.menu-line > a {
  width: calc(25% - 4px);
  min-width: 60px;
  height: 28px;
  margin: 4px;
  margin-right: 2px;
  margin-left:  2px;
  margin-bottom:  2px; 
  overflow: hidden;
}
.no-story {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 50%; min-width: 300px;
}
.no-story > img {
  width: 100%;
  height: 300px;
  object-fit: scale-down;
  margin-bottom: 16px;
}
.noborder-button {
  background: transparent;
  border-radius: 50%;
  border: solid thin #EE9C98;
  padding: 0;
  height: 25px;
  width: 25px;
}
.msg-btn {
  font-size: 18px;
  background: white;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #dbdbdb;
}
.msg-btn:hover {
  cursor: pointer;
}
.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
.drawer-menu-wrapper {
  position: absolute;
  z-index: 10;
  top: 80px;
  right: 0;
  width: 50%;
  height: calc(100% - 80px);
  background-color: white;
  overflow: hidden;
  h1 {
    font-weight: bold;
    font-size: 20px;
  }
}
.drawer-menu {
  padding: 24px;
}
.close-btn {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 24px;
}
.close-btn:hover {
  cursor: pointer;
}
.tab-container {
  margin:16px;
}
.modal-mask {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color:rgba(10, 10, 10, 0.76);
}
.action-table {
  th, td {
    font-size: 12px;
    padding: 8px;
    white-space: nowrap;
  }
}
.finish-reading, .question {
  cursor: pointer;
}
.finish-reading:hover, .question:hover {
  background: #ffeef8;
}
.finish-reading-comment-wrapper, .question-comment-wrapper {
  border: 1px solid #dbdbdb;
  padding: 16px;
  text-align: left;
  border-radius: 5px;
  min-height: 400px;
  font-size: 14px;
}
.finish-reading-comment-reply-wrapper, .question-comment-reply-wrapper {
  border: 1px solid #dbdbdb;
  padding: 16px;
  margin-bottom: 16px;
  text-align: left;
  border-radius: 5px;
  min-height: 150px;
  font-size: 14px;
  background-color: #f4f4f4;
}
.quiz-question-wrapper {
  border: 1px solid #dbdbdb;
  padding: 16px;
  text-align: left;
  border-radius: 5px;
  min-height: 40px;
  font-size: 14px;
}
.quiz-result-wrapper {
  width: calc(100% - 32px);
  margin-left: 16px;
  height: 56px;

  .quiz-result {
    width: 100%;
    padding-top: 16px;
    overflow-y: hidden;
  }
}
.quiz-choice-wrapper {
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  min-height: 30px;
  font-size: 14px;
  margin: 0px 32px 8px 32px;
  padding: 8px;
}
.quiz-select {
  border: 3px solid #555555;
}
.quiz-collect {
  color: red;
}
.quiz-incollect {
  color: blue;
}

.arrow-left-wrapper {
  text-align: left;
  margin-bottom: 8px;
  i {
    cursor: pointer;
  }
}
.action-list {
  position: relative;
  height: 500px;
  margin-top: 40px;
  will-change: transform;
}
table {
  table-layout: fixed;
  width: 100%;
}
// ヘッダーだけ固定したいが、うまくいかない
th {
  position: sticky;
  top: 0;
  background: #dbdbdb;
  z-index: 2;
}
.drag-button {
  cursor: grab;
  border     : none;
  padding    : 0;
}
.sent-p {
  font-size: 14px;
  text-align: left;
  margin-bottom: 8px;
}
.reply-p {
  font-size: 14px;
  text-align: left;
  margin-bottom: 8px;
}
.reply-textarea {
  margin-bottom: 8px;
  height: 320px;
}
.reply-email-msg-check-p {
  font-size: 14px;
  text-align: left;
  margin-bottom: 8px;
}
.reply-email-msg-check {
  white-space: pre-line;
  text-align: left;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #dbdbdb;
  height: 320px;
  margin-bottom: 8px;
  border: 1px solid #AA0066;
}
.mail-send-btn-wrapper {
  .btn {
    width: 120px;
  }
}
.new-messages-container {
  margin: 16px;
}
.new-messages {
 position: absolute;
 font-size:80%;
 padding: 0px 5px;
 color: #ffffff;
 background: rgb(214, 24, 81);
 border-radius: 8px;
 animation: flash 1.5s linear infinite;
 z-index: 1;
}
.new-messages, -item {
  position: absolute;
  left: 0;
  top: -8px;
}

$unread-zero-width: 41.6%; 
$unread-one: 29.2%;
$unread-two: 29.2%;

.unread-zero {
  position: relative;
  width: $unread-zero-width;
}
.unread-one {
  position: relative;
  margin-left: $unread-zero-width;
  width: $unread-one
}
.unread-two {
  position: relative;
  margin-left: $unread-zero-width + $unread-one;
  width: $unread-two;
}
.unread-parent{
 position: relative;
}
.unread-child{
 position: absolute;
 left: -32px;
}
.unread-mark{
 float: left;
 width: 10px;
 height: 10px;
 border-radius: 50%;
 background: greenyellow;
 margin-top: 3px;
}
.already-read-mark{
 float: left;
 width: 10px;
 height: 10px;
 border-radius: 50%;
 border: solid thin #CCC;
 background: transparent;
 margin-top: 3px;
}
.maru {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  flex-flow: column; 
  vertical-align: middle;
}
.size_normal{
  width: 20px;
  height: 20px;
}
.letter_already {
  font-size: 4px;
  top: -4px;
}
.red_already {
  color: red;
  border: 1px solid red;
}
@media screen and (max-width: 1200px) {
  .menu-line {
    margin-bottom: 8px;
  }
  .menu-line > button {
    font-size: 10px;
  }
  .menu-line > a {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Story/StoryList.vue